import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import tableau from 'tableau-api';

let viz;

export const ShowExportPDFDialog = () => {
	viz.showExportPDFDialog();
};

const TableauDashboard = (props) => {
	const { url } = props;
	// const url = "https://public.tableau.com/views/VacationHome/VacationHome?:embed=y&:display_count=yes";

	const _initViz = () => {
		if (viz) {
			viz.dispose();
		}

		const containerDiv = document.getElementById('dashboard');
		const options = {
			// hideTabs: true,
			hideToolbar: true,
			width: '100%',
			height: '100vh',
			onFirstVizSizeKnown(innerHeight) {
				containerDiv.setAttribute('style', `height:${innerHeight}px`);
			}
		};

		viz = new window.tableau.Viz(containerDiv, url, options);
		// Create a viz object and embed it in the container div.
	};

	useEffect(() => {
		if (url) {
			_initViz();
		}
	}, [url]);

	if (!url) {
		return null;
	}

	return (
		<div id="dashboard" style={{ width: '100%' }} />
	);
};

TableauDashboard.propTypes = {
	url: PropTypes.string.isRequired
};

export default TableauDashboard;
